import React, { Component, Fragment } from 'react'
import { translate } from 'react-i18next'
import ButtonClose from '../ButtonClose'
import CustomSelect from './CustomSelect'
import Drawer from 'antd/lib/drawer'
import { options } from '../../utils/constants'
import { resolutions } from '../../utils/constants'
import SimpleBtn from '../SimpleBtn'
import './index.sass'

class FilterContainer extends Component {
  state = {
    isVisible: false,
    width: window.innerWidth,
  }

  updateDimensions = () => {
    this.setState({ width: window.innerWidth })
  }
  componentDidMount() {
    window.addEventListener('resize', this.updateDimensions)
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions)
  }

  onChangeVisibility = () => {
    this.setState({
      isVisible: !this.state.isVisible,
    })
  }

  handleChange = (e, optionName) => {
    this.props.handleChangeFilter(e, optionName)
  }

  render = () => {
    const {
      languages,
      opt,
      ages,
      clearAllFilters,
      t,
      toggleVisibleAudioPlayer,
      setPlayingStatus,
    } = this.props
		const { width } = this.state
    options[0].values = languages
    options[2].values = ages
    return width <= resolutions.tablet ? (
      <Fragment>
        <div
          className="filter"
          onClick={() => {
            setPlayingStatus(false)
            toggleVisibleAudioPlayer(false)
            this.onChangeVisibility()
          }}
        ></div>
        <Drawer
          placement="right"
          closable={false}
          onClose={this.onChangeVisibility}
          visible={this.state.isVisible}
          width="100%"
          className="drawer-container"
        >
          <header className="drawer-header">
            <h5>{t('general.filters')}</h5>
            <ButtonClose
              onHandleClick={() => {
                toggleVisibleAudioPlayer(true)
                this.onChangeVisibility()
              }}
            />
          </header>
          <div className="select-wrapper">
            {options.map((elem, ind) => (
              <CustomSelect
                clearAllFilters={clearAllFilters}
                opt={opt}
                handleChange={this.handleChange}
                option={elem}
                key={ind}
              />
            ))}
            <SimpleBtn
              onHandleClick={this.onChangeVisibility}
              btnName={`${t('general.show')} (${this.props.numberOfResults})`}
              border
            />
          </div>
        </Drawer>
      </Fragment>
    ) : (
      <div className="select-wrapper">
        {options.map((elem, ind) => (
          <CustomSelect
            clearAllFilters={clearAllFilters}
            opt={opt}
            handleChange={this.handleChange}
            option={elem}
            key={ind}
          />
        ))}
      </div>
    )
  }
}

export default translate('translations')(FilterContainer)
